require('./vizacademy.css');

import {
  THEME_URL
} from './js/global';

import {
  Site
} from './js/site';

__webpack_public_path__ = `${THEME_URL}/`;

new Site();